// extracted by mini-css-extract-plugin
module.exports = {"labeledIconMenu__wrapper":"labeledIconMenu__wrapper","header__labeledIconWrapper":"header__labeledIconWrapper"};